import React, { useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { message as toast } from "antd";
import { isFocusEnv, FocusSDK } from "@/utils";
import ComNoticeCard from "@/baseComponents/ComNoticeCard";
import { changeEgovUrl } from "@/utils/tools";
import { joinMeeting } from "@/components/Meeting/utils";
import Avatar from "@/components/Avatar";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { handleLinkClick } from "./utils";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";

export default function ({ message }: { message: any }) {
  const { currentEmployee } = useContext<GlobalContextConfig>(GlobalContext);
  const { title, extend, infox = {} } = message;
  const [click, setClick] = useState(false);

  const [t] = useTranslation("chat");
  const content = extend.fields;

  const deepLink = DeeplinkEvent.parseDeeplink(infox.deepLink);
  const mparams = deepLink?.mparam || {};

  const handleJoin = useCallback(() => {
    if (click) {
      return;
    }
    setClick(true);
    setTimeout(() => {
      setClick(false);
    }, 2000);

    const meetingNum =
      infox.meetingNumber || content.find((i: any) => i.key === "meetNumber")?.value;

    if (isFocusEnv()) {
      joinMeeting(
        {
          meetingId: meetingNum,
          password: infox.password || mparams.meetingPassword || "",
          realName: currentEmployee.name
        },
        true,
        true
      ).catch((e) => {
        console.error(e);
        toast.error(e?.message || e || "加入会议失败");
      });
    } else {
      toast.warn("暂不支持");
    }
  }, [click, infox, content, mparams.meetingPassword, currentEmployee.name]);

  const handleClick = () => {
    if (infox.action === "joinmeeting") {
      handleJoin();
    } else if (extend.url) {
      handleLinkClick(extend.url);
    } else {
      FocusSDK.printLog("unknown meeting notice card");
      toast.warn("当前版本暂不支持，请升级至最新版本");
    }
  };

  const loadButtons = () => {
    if (infox.action === "joinmeeting") {
      if (!isFocusEnv()) {
        return null;
      }
    }

    if (infox.btnName || extend.url) {
      return (
        <div
          className="button_item"
          onClick={() => {
            handleClick();
          }}
        >
          {infox.btnName || "查看详情"}
        </div>
      );
    }
    return null;
  };

  if (extend.messageFormatVer === "v2") {
    return (
      <ComNoticeCard
        message={message}
        avatarSrc={changeEgovUrl(message.sender.avatar)}
        type={extend.applicationName}
        contentList={content}
        title={title}
        loadButtonsFn={loadButtons}
      />
    );
  }

  const fromUser = mparams.fromUser;
  return (
    <div className="notice-card notice-card-joymeeting">
      <div className="notice-card-header">
        <div className="notice-card-title">
          {t("joyMeeting.create meeting")}-{title}
        </div>
        {content && <div className="notice-card-content">{content}</div>}
      </div>
      {fromUser && (
        <div className="notice-card-from">
          <Avatar
            style={{
              borderRadius: "50%",
              width: 26,
              height: 26,
              marginRight: 5
            }}
            src={changeEgovUrl(fromUser.avatar)}
          />
          <span>{fromUser.name}</span>
        </div>
      )}
      <div className="notice-card-action">
        <div className="notice-card-action-view" onClick={handleJoin}>
          {t("joyMeeting.joinMeeting")}
        </div>
      </div>
    </div>
  );
}
